//Model for:
//  • User
//  • UserResponse
//  • UsersResponse

export class User {
  user_id: number;
  email: string;
  username: string;
  account_type: string;
  firstname: string;
  lastname: string;
  updatedpassword_at: string;
  

  // Previously failed attempting to cast FirebaseListObservable to Products[].
  constructor(
    user_id: number,
    email: string,
    username: string,
    account_type: string,
    firstname: string,
    lastname: string,
    updatedpassword_at: string
  ){
    //typescript will not autoassign the formal parameters to related properties for exported classes.
    this.user_id = user_id;
    this.email = email;
    this.username = username;
    this.account_type = account_type;
    this.firstname = firstname;
    this.lastname = lastname;
    this.updatedpassword_at = updatedpassword_at;

  }


 
  //Class method to convert firebaselistobservables to pure array of Products
  //Caller: product.service:getProducts()
  static fromJsonList(users:any): User[] {
    let mappedArray = users.map(User.fromJson); 
    return mappedArray;
  }

  //add more parameters depending on your database entries and Hero constructor
  // *note: parameters must match the key-names of be those of the any[] firebase list object.  
  //        Thus '$key', 'firstName', etc.
  //  **note: the value passed in must be of type any.
  static fromJson({ 
    user_id,
    email,
    username,
    account_type,
    firstname,
    lastname,
    updatedpassword_at,
  }): User {
    return new User(
      user_id,
      email,
      username,
      account_type,
      firstname,
      lastname,
      updatedpassword_at,
    );
  }
}


//response to: authenticate user response
export interface AuthenticateResponse{
  success: boolean;
  msg: string;
  token: string;
  user: User;
}

//response to: get single user
export interface UserResponse {
  success: boolean;
  msg: string;
  user: User;
}

//response to: admin get all users
export interface UsersResponse {
  success: boolean;
  msg: string;
  users: User[];
}


// WEBPACK FOOTER //
// ./src/app/models/User.ts